import { render, staticRenderFns } from "./DashboardTile.vue?vue&type=template&id=bd364a7e&"
import script from "./DashboardTile.vue?vue&type=script&lang=js&"
export * from "./DashboardTile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports